// Feature flag names
export const SCAN_USR_LIB_JARS_FEATURE_FLAG = 'scanUsrLibJars';
export const CONTAINER_CLI_APP_VULNS_ENABLED_FEATURE_FLAG =
  'containerCliAppVulnsEnabled';

// CLI option names
export const INCLUDE_SYSTEM_JARS_OPTION = 'include-system-jars';
export const EXCLUDE_APP_VULNS_OPTION = 'exclude-app-vulns';
export const APP_VULNS_OPTION = 'app-vulns';
